import axios from "axios";

export const deleteTableAPI = (obj) => {
  return axios.post(`/pmdm/admin/cls/deleteCustomizeFrame`, obj);
};

export const deleteAttriAPI = (obj) => {
  return axios.post(`/pmdm/admin/cls/deleteCustomizeFrameAttribute`, obj);
};

export const upDateAttriAPI = (obj) => {
  return axios.post(`/pmdm/admin/cls/updateCustomizeFrameAttr`, obj);
};

export const saveTableFrame = (obj) => {
  return axios.post(`/pmdm/admin/cls/saveCustomizeFrame`, obj);
};

export const queryTableAPI = (obj) => {
  return axios({
    url: `/pmdm/admin/cls/queryCustomizeFrameSetting`,
    method: "get",
    params: obj,
  });
};
